import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'join',
    standalone: true
})
export class JoinArrayPipe implements PipeTransform {

  transform(value: string[], separator = ',\n'): string {
    return value?.join(separator);
  }

}
